export const initialState= {
	dataType:'matches', //match is for displaying scan result and match square in QrMatch page. matches is for displaying matched records in QrManage page.
	rows:[], //Array of Data for table.
	stage:"REQUEST_RECORDS", //"REQUEST_RECORDS" stage request data from backend server. "DISPLAY_RECORDS" stage display table of datas.
	keyword:"",
	limit:"6", // Number of datas for each page of table.
	offset:"0", // Starting data position. Page one is 0, page two is 1 x limit, page three is 2 x limit....
	count:0, //Number of datas for current searching result. It will be used for calculating total number of pagination of table.
	requestCount:"true", //If not "true", backend server will not count total number of result.
	sort:{"Create Time": "descending"} //Column Name : Order Direction ("descending" or "ascending"). If not given,
};
